import React from 'react';

/* Simboli aktivnosti kao na tahografu (vožnja = volan, ostali rad = ukršteni čekići, raspoloživost = kvadrat sa
   dijagonalom, odmor = krevet), u boji aktivnosti (--ui-act-* tokeni). Crtaju se linijom boje teksta (currentColor). */
const BOJA = {
    driving: 'var(--ui-act-driving)',
    availability: 'var(--ui-act-availability)',
    work: 'var(--ui-act-work)',
    'break/rest': 'var(--ui-text-muted)',
    unknown: 'var(--ui-text-subtle)',
};

const OBLIK = {
    driving: (
        <>
            <circle cx="12" cy="12" r="8.5" />
            <circle cx="12" cy="12" r="2.2" />
            <path d="M3.6 10.5 L9.8 11.5 M14.2 11.5 L20.4 10.5 M12 14.2 L12 20.5" />
        </>
    ),
    work: (
        <>
            <path d="M6 18 L15.5 8.5" />
            <path d="M18 18 L8.5 8.5" />
            <path d="M13.2 6.2 L17.8 10.8 M15.5 8.5 L17 7" />
            <path d="M10.8 6.2 L6.2 10.8 M8.5 8.5 L7 7" />
        </>
    ),
    availability: (
        <>
            <rect x="4.5" y="4.5" width="15" height="15" />
            <path d="M4.5 19.5 L19.5 4.5" />
        </>
    ),
    'break/rest': (
        <>
            <path d="M3.5 7 L3.5 18 M3.5 14.5 L20.5 14.5 L20.5 18" />
            <path d="M8.5 14.5 L8.5 11 L20.5 11 L20.5 14.5" />
            <circle cx="6" cy="11.5" r="1.6" />
        </>
    ),
    unknown: <path d="M9 9 a3 3 0 1 1 3 3 L12 14.5 M12 18 L12 18.5" />,
};

/** simbol aktivnosti; uz tekst (sa labelom) ili sam (title za čitače ekrana) */
export default function AktivnostSimbol({ tip, label, size = '1.15rem' }) {
    const oblik = OBLIK[tip] || OBLIK.unknown;
    return (
        <span className="akt-simbol" style={{ color: BOJA[tip] || BOJA.unknown }}>
            <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"
                aria-hidden={label ? 'true' : undefined} role={label ? undefined : 'img'}>
                {oblik}
            </svg>
            {label && <span className="akt-simbol-tekst">{label}</span>}
        </span>
    );
}
